<template>
  <div class="flex flex-col items-center justify-center">
    <h3
      class="mt-0 text-[20px] font-ff-good-pro-cond font-medium !leading-[26px] md:text-[24px] md:!leading-[34px] text-center text-black"
    >
      {{ $t("common.choose_your_gender") }}
    </h3>
    <div class="grid grid-cols-2 gap-4 mt-[30px] mb-10">
      <label
        for="male"
        :class="gender == 'male' ? 'border-black' : 'border-light-gray-600'"
        class="cursor-pointer w-[168px] md:w-[260px] border rounded-md flex flex-col justify-center items-center py-5"
      >
        <Man class="h-auto w-full md:w-[211px]" />

        <span class="flex items-center gap-2">
          <input
            id="male"
            v-model="gender"
            type="radio"
            value="male"
            class="relative text-transparent bg-transparent border-2 border-black rounded-full cursor-pointer checked:focus:border-black checked:border-black checked:hover:border-black checked:bg-transparent focus:ring-0"
          />
          {{ $t("common.male") }}
        </span>
      </label>
      <label
        for="female"
        :class="gender == 'female' ? 'border-black' : 'border-light-gray-600'"
        class="cursor-pointer w-[168px] md:w-[260px] border rounded-md flex flex-col justify-center items-center py-5"
      >
        <Woman class="h-auto w-full md:w-[211px]" />

        <span class="flex items-center gap-2">
          <input
            id="female"
            v-model="gender"
            type="radio"
            value="female"
            class="relative text-transparent bg-transparent border-2 border-black rounded-full cursor-pointer checked:focus:border-black checked:border-black checked:hover:border-black checked:bg-transparent focus:ring-0"
          />
          {{ $t("common.female") }}
        </span>
      </label>
    </div>
    <Btn
      type="button"
      size="lg"
      block
      :rounded="false"
      class="w-full md:!w-auto uppercase rounded-md px-[30px]"
      color="primary"
      v-text="$t('common.next')"
      @click="goNext"
    />
  </div>
</template>
<script setup>
import Man from "~/assets/svg/calculate-size/man.svg?component";
import Woman from "~/assets/svg/calculate-size/woman.svg?component";
import { useCalculateBikeSizeStore } from "~/store/calculatebikesize";

const calculateBikeSizeStore = useCalculateBikeSizeStore();
const emit = defineEmits();

const gender = ref(calculateBikeSizeStore.form.gender);

function goNext() {
  calculateBikeSizeStore.updateForm("gender", gender.value);
  emit("next", "bike-modal");
  const timeout = setTimeout(() => {
    const containerEl = document.getElementById("calculate");
    if (containerEl) {
      containerEl.scrollIntoView({
        behavior: "smooth",
      });
    }
    clearTimeout(timeout);
  }, 5);
}
</script>
<style scoped>
.calculate-bike-size [type="radio"]:checked {
  background-image: url("data:image/svg+xml;charset=utf-8,<svg xmlns='http://www.w3.org/2000/svg' fill='#000' viewBox='0 0 16 16'><circle cx='8' cy='8' r='3'/></svg>") !important;
}
</style>